import * as type from 'constants/ActionTypes';

export const fetchFleetbackPack = () => ({
  type: type.FETCH_FLEETBACK_PACK_REQUEST,
});

export const fetchFleetbackPackSuccess = pack => ({
  type: type.FETCH_FLEETBACK_PACK_SUCCESS,
  pack,
});

export const fetchFleetbackPackFailure = (error, meta = {}) => ({
  type: type.FETCH_FLEETBACK_PACK_FAILURE,
  payload: error,
  error: true,
  meta,
});
